import React, { useState } from "react";
import { Modal} from "react-bootstrap";
import ContactUsSection from "./ContactUsSection";

export const Contact = () => {
  const [showContactModal, setShowContactModal]=useState(false);
  const handleShowContactModal = () => setShowContactModal(true);
  const handleCloseContactModal = () => setShowContactModal(false);
  return (
    <div className="img-container bg-dark" style={{ marginTop: "0", padding: "100px 20px" }}>
      {/* Background Video */}
      <img src='/assets/images/contactbackground.jpg' alt='background' className="img-background mt-5 mb-5"/>

      {/* Content Overlay */}
      <div className="content">
        <h1 className='display-1'>Connect With Alex</h1>
        <div className="btn-wrap">
          <a href="#home" class="lp-btn" onClick={handleShowContactModal}>Contact Alex</a>
        </div>
      </div>

      <Modal show={showContactModal} onHide={handleCloseContactModal} fullscreen>
        <Modal.Header closeButton>
          <h1 className="ms-5">Contact Us</h1>
        </Modal.Header>
        <Modal.Body>
          <ContactUsSection />
        </Modal.Body>
        
      </Modal>

      
    </div>
  )
}
